import Markdown from './Markdown';
export { Markdown as default, Markdown };